import API from "../config/api.js";

export const ProductCategoryService = {
  getCategoryList(search = "", page = 1) {
    return API.get(`api/products/categories/list`, {
      params: { search, page },
    });
  },

  getCategoryInfo(uuid) {
    return API.get(`api/products/category/info/${uuid}`);
  },

  createCategory(data) {
    return API.post(`/api/products/category_create`, data);
  },

  updateCategory(uuid, data) {
    console.log("Updating category:", uuid, data);
    return API.put(`/api/products/category/update/${uuid}`, data);
  },

  dropCategory(uuid) {
    return API.delete(`/api/products/category/delete/${uuid}`);
  },
};
